/*
This would (I think) be the compiled TypeScript version of:

enum CookieOptions {
    denied,
    analytical,
    marketing,
    video,
    all
}
*/

let CookieOptions
(function (CookieOptions) {
    CookieOptions[CookieOptions['denied'] = 0] = 'denied'
    CookieOptions[CookieOptions['analytical'] = 1] = 'analytical'
    CookieOptions[CookieOptions['marketing'] = 2] = 'marketing'
    CookieOptions[CookieOptions['all'] = 3] = 'all'
})(CookieOptions || (CookieOptions = { }))

export default CookieOptions